import { applyFilters, doRequest } from "./helpers";
import isNil from "lodash/isNil";
import omitBy from "lodash/omitBy";

export default class RecipientService {
  static async getTable(filters = null) {
    let path = "/recipient/";
    path = applyFilters(filters, path);
    return doRequest("GET", path);
  }

  static async getForFilters(filters = null) {
    let path = "/recipient/for_filters";
    path = applyFilters(filters, path);
    return doRequest("GET", path);
  }

  static async get(id) {
    return doRequest("GET", `/recipient/${id}`);
  }

  static async create(data) {
    return doRequest("POST", "/recipient/", { data: omitBy(data, isNil) });
  }

  static async update(id, data) {
    return doRequest("PUT", `/recipient/${id}`, { data: omitBy(data, isNil) });
  }

  static async delete(id) {
    return doRequest("DELETE", `/recipient/${id}`);
  }
}
